import React from "react";
import {
  Typography,
} from "antd";
import {
  Avatar,
} from "@webiz/admin-design-system";

const { Paragraph } = Typography;

const columns = (params?: {
  navigateToDetails?: (entityId: number, type: string) => void;
}): any => {
  return [
    {
      title: "Username",
      dataIndex: "nickname",
      key: "nickname",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      width: 250,
      render: (_value: any, record: any) => {
        return (
          <div
            style={{ display: "flex", alignItems: "center", cursor: 'pointer' }}
            onClick={() => {
              params?.navigateToDetails?.(record?.id, record?.user_type)
            }}
          >
            <div style={{
              borderRadius: '50%',
              border: `2px solid ${record.user_type === 'client' ? '#38C976 ' : record.user_type === 'artist' ? '#9540EC' : record.user_type === 'user' ? '#FFBD00' : '#a6acbe'}`
            }}>
              <Avatar
                size="xs"
                avatarUrl={record.avatar}
              />
            </div>
            <Paragraph
              ellipsis={{ tooltip: true }}
              className="employee-truncate-tooltip"
              style={{ zIndex: 1, marginLeft: 16 }}
            >
              {record?.nickname}
            </Paragraph>
          </div>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "user_type",
      key: "user_type",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      title: "Paying",
      dataIndex: "total-spent",
      key: "total-spent",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (paying: string) => (
        <span style={{ fontWeight: 500 }}>{paying}</span>
      ),
    },
    {
      title: "Earning",
      dataIndex: "total-received",
      key: "total-received",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (earning: string) => (
        <span style={{ fontWeight: 500 }}>{earning}</span>
      ),
    },
    {
      title: "Active subs",
      dataIndex: "active_subs",
      key: "active_subs",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (totalSubs: string) => (
        <span style={{ fontWeight: 500 }}>{totalSubs}</span>
      ),
    },
    {
      title: "First transaction",
      dataIndex: "first-transaction",
      key: "first-transaction",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      title: "Last transaction",
      dataIndex: "last-transaction",
      key: "last-transaction",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      title: "First payment",
      dataIndex: "first-transaction",
      key: "firstPayment",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      title: "Last payment",
      dataIndex: "last-transaction",
      key: "lastPayment",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      title: "First earning",
      dataIndex: "first-transaction",
      key: "firstEarning",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      title: "Last earning",
      dataIndex: "last-transaction",
      key: "lastEarning",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
    },
    {
      title: "Sign up",
      dataIndex: "created_at",
      key: "created_at",
      sortDirections: ['ascend', 'descend', 'ascend'],
      defaultSortOrder: 'descend',
      sorter: true,
    },
    {
      title: "Last log In",
      dataIndex: "last_active",
      key: "last_active",
      sortDirections: ['ascend', 'descend', 'ascend'],
      width: 150,
      sorter: true,
    },
  ];
};

export default columns;
